// Canonical kpiCustomData.period values — these are written verbatim into
// kpiCustomData.period via periodLengthMappings.target. Downstream consumers
// (Multiperiod grid, Financials tab) do case-sensitive lookups, so these
// must match the canonical PascalCase/uppercase forms exactly.
export const KPI_PERIODS = [
  { value: 'Month', label: 'Month' },
  { value: 'Quarter', label: 'Quarter' },
  { value: 'Year', label: 'Year' },
  { value: 'LTM', label: 'LTM (Last 12 Months)' },
  { value: 'L3M', label: 'L3M (Last 3 Months)' },
  { value: 'CYTD', label: 'CYTD (Calendar Year-to-Date)' },
  { value: 'FYTD', label: 'FYTD (Fiscal Year-to-Date)' },
  { value: 'GrowthMonth', label: 'Growth (Month)' },
  { value: 'GrowthQuarter', label: 'Growth (Quarter)' },
  { value: 'GrowthYear', label: 'Growth (Year)' },
] as const;

// KPI section target values (KpiCustomDataSection)
export const KPI_SECTIONS = [
  { value: 'actual', label: 'Actual' },
  { value: 'budget', label: 'Budget' },
] as const;
